import { OnInit, Input, Output, EventEmitter } from '@angular/core';

import { FsItem, FsStore } from '@models';
import { IFsItemAction } from './fs-actions/fs-actions.interface';
import { EFsContentType, ERoleMode, ERoleActions } from '@enums';
import { StoreService } from '@services';

export class FsItemComponent implements OnInit {
  @Input() fsItem: FsItem;
  @Input() fsStore: FsStore;
  @Output() fsItemActionClick = new EventEmitter<IFsItemAction>();
  @Output() fsItemClick = new EventEmitter<FsItem>();

  EFsContentType = EFsContentType;
  ERoleMode = ERoleMode;
  ERoleActions = ERoleActions;

  constructor(public storeService: StoreService) {}

  ngOnInit() {}

  onFsItemActionClick(event: IFsItemAction) {
    this.fsItemActionClick.emit(event);
  }

  onItemClick() {
    if (this.fsItem.isFolder) {
      this.fsItemClick.emit(this.fsItem);
    }
  }
}
